import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import * as firebase from "firebase";
import vuetify from "./plugins/vuetify";
import { sync } from "vuex-router-sync";

import { VTooltip, VClosePopover } from "v-tooltip";

Vue.directive("tooltip", VTooltip);
Vue.directive("close-popover", VClosePopover);
Vue.config.productionTip = false;
window.$ = window.jQuery = require("jquery");

// sync store and router
sync(store, router);

//const firebaseConfig = {
//  apiKey: "AIzaSyDh_SVVKPYbRxZZxbMU8s0tQ7AHg5OIuh0",
//  authDomain: "smartparticipa-qa-880e3.firebaseapp.com",
//  databaseURL: "https://smartparticipa-qa-880e3.firebaseio.com",
//  projectId: "smartparticipa-qa-880e3",
//  storageBucket: "smartparticipa-qa-880e3.appspot.com",
//  messagingSenderId: "203420184422",
//  appId: "1:203420184422:web:f21b92001f325f587c62a7",
//  measurementId: "G-DYPYTEM45G"
//};

const firebaseConfig = {
  apiKey: "AIzaSyANT5wHCIK9TcPld68E2S3-bkUZKVBjBVo",
  authDomain: "smartparticipa.firebaseapp.com",
  databaseURL: "https://smartparticipa.firebaseio.com",
  projectId: "smartparticipa",
  storageBucket: "smartparticipa.appspot.com",
  messagingSenderId: "1084469724143",
  appId: "1:1084469724143:web:fd4fd92de251651c06ec1a",
  measurementId: "G-YCQJNCC0DK"
};

//export const orcidRedirectUri = "https://smartparticipa-qa-880e3.web.app";
//export const orcidRedirectUri = "http://localhost:8081";
export const orcidRedirectUri = "https://participainteligente.org";

firebase.initializeApp(firebaseConfig);
// eslint-disable-next-line no-unused-vars
firebase.auth().onAuthStateChanged(function (user) {

  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount("#app");
});
